import styled from "styled-components"
import { AlignBox, EmtpyBox } from "../atom"
import { useLocation, useNavigate } from "react-router-dom"
import { useState, HTMLAttributes, useEffect } from "react"
import { PopUp, SharePopUp } from "../component/PopUp"
import { postAPI } from "../apis/useAPI"
import { trackEvent } from "../apis/amplitude"

const Question = () => {

    
    const [choose , setChoose] = useState(0);
    const [popUp, setPopUp] = useState(false);
    const [sharePopUp, setSharePopUp] = useState(false);
    const [btn_text, setBtn_text] = useState('시작하기');
    
    const nav = useNavigate();
    const id = useLocation().state.id;

    useEffect(() => trackEvent('질문 선택', {id: id, questionNum: choose}), [choose])
    useEffect(() => trackEvent(`공유할래요 팝업 ${sharePopUp}`, {id: id}), [sharePopUp])
    useEffect(() => trackEvent(`사람 없어요 팝업 ${popUp}`, {id: id}), [popUp])

    const ClickHander = async () => {

        trackEvent('채팅 찾기 클릭', {id: id, questionNum: choose, btn_text: btn_text});

        if(choose === 0) return alert('취향을 선택해주세요');

        if(btn_text === '같은 대답한 사람 찾는 중...') return;
        if(btn_text === '상대를 기다리고 있어요...') return;
        
        setBtn_text('같은 대답한 사람 찾는 중...');

        
        const {roomNum} = await postAPI('getRoomNum', {question: choose});
        trackEvent('방 찾기', {id: id, questionNum: choose, roomNum: roomNum});

        setBtn_text('상대를 기다리고 있어요...');
        console.log("roomNum:", roomNum);

        let count = 0;

        const intervalId = setInterval( async () => {

            count++;

            const {waitting} = await postAPI('waitting', {roomNum: roomNum, question: choose});

            if(count === 100){
                clearInterval(intervalId);
                setBtn_text('다시 찾을래요');
                await postAPI('getRoomNum', {question: choose});
                setPopUp(true);
            }

            if(!waitting){
                setPopUp(false);
                clearInterval(intervalId);
                nav(`/chatting`, {state: {roomNum: roomNum, id: id}});
            }
        }, 100);
        
    }

    return (
        <AlignBox align="center">
            {
                popUp && 
                <PopUp 
                    xBtnHandler = {()=> setPopUp(false)}
                    BtnHandler = {()=> {
                        window.open("https://www.tumblbug.com/soulappteam");
                        trackEvent('텀블벅 프로필 이동 사람 없음)')
                        // setPopUp(false)
                        // setSharePopUp(true)
                    }} />
            }
            {
                sharePopUp && 
                <SharePopUp 
                    xBtnHandler = {()=> setSharePopUp(false)}
                />
            }
            <div style={{height: '40px'}}/>
            <h3>오늘의 질문</h3>
            <div style={{height: '40px'}}/>
            <QuestionBox>
                최고의 하루를 보낸다면
            </QuestionBox>
            <div style={{height: '40px'}}/>
            <AlignBox align="center" direction="row">
                <ChooseBox 
                    onClick={()=>{setChoose(1)}}
                    active={choose === 1}
                >
                혼자<br/>
                방에서<br/>
                트위터<br/>
                둘러보기<br/>
                </ChooseBox>
                <div style={{width: '20px'}}/>
                <ChooseBox
                    onClick={()=>setChoose(2)}
                    active={choose === 2}
                >
                친구랑<br/>
                밖에서<br/>
                인스타<br/>
                사진찍기<br/>
                </ChooseBox>
            </AlignBox>
            <EmtpyBox height={30} />
            <Btn onClick={ClickHander}>{btn_text}</Btn>
        </AlignBox>
    )
}


const Btn = styled.div`
    position: absolute;
    bottom: 20px;
        
    display: flex;
    justify-content: center;
    align-items: center;
    width: 268px;
    height: 55px;
    background-color: #466FFF;
    border-radius: 32px;
    color: #fff;
`

interface ChooseBoxProps extends HTMLAttributes<HTMLDivElement>{
    active: boolean;
}

const ChooseBox = styled.div<ChooseBoxProps>`

    font-size: 20px;
    font-weight: 700;

    padding: 94px 0;
    width: 140px;
    height: 280px;
    background: ${({active})=> active ? "#DCDCDC" : "#fff"};
    border-radius: 17px;
    border: 0.50px black solid
`

const QuestionBox = styled.div`

    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 20px;
    font-weight: 700;

    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);

    padding: 44px 28px;

    width: 291px;
    height: 80px;
    border: 1px solid #D9D9D9;
    border-radius: 20px;
`

export default Question